module.exports = __webpack_public_path__ + "img/logo_noa1-300x150.422e1ff5.png";